export class Price {
  constructor(amount, unit = 1) {
    const token = amount.toString()
    this.amount = Number(this._removeComma(this._toHalfWidth(token)))
    this.unit = unit
  }

  convert_by_base_unit(unit) {
    return (this.to_i() / unit).toFixed(1)
  }

  to_i() {
    return this.amount * this.unit
  }

  _removeComma(token) {
    return token.replace(/,/g, '')
  }

  // https://gist.github.com/heeju/517b8d8a01ba2de3a8eb
  _toHalfWidth(token) {
    return token.replace(/[！-～]/g, function(r){
      return String.fromCharCode(r.charCodeAt(0) - 0xFEE0)
    })
  }
}
